import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useContext, useMemo, createContext } from 'react';
import { css, createGlobalStyle, useTheme as useTheme$1, ThemeProvider as ThemeProvider$1 } from 'styled-components';
import { tooltipGlobalStyle } from '../../components/Tooltip/Tooltip.esm.js';
import { createCssVar, fontObjectToCssVar } from '../../helpers/theme.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    ",
        "\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  :root {\n    ",
        "\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function mapColorsToCssVariables(colors) {
    return css(_templateObject(), Object.entries(colors).map(function(param) {
        var _param = _sliced_to_array(param, 2), colorName = _param[0], colorValue = _param[1];
        return createCssVar("".concat(colorName, "-color"), colorValue);
    }).join(""));
}
function mapFontsToCssVariables(fonts) {
    return css(_templateObject1(), Object.entries(fonts)// eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error, @typescript-eslint/ban-ts-comment
    // @ts-ignore - fontType defined as string in cdk theme, but as FontType in bluis/nuis
    .map(function(param) {
        var _param = _sliced_to_array(param, 2), fontType = _param[0], fontProps = _param[1];
        return fontObjectToCssVar(fontType, fontProps);
    }).join(""));
}
var GlobalCSSVariablesProvider = createGlobalStyle(_templateObject2(), function(param) {
    var colors = param.colors;
    return mapColorsToCssVariables(colors);
}, function(param) {
    var fonts = param.fonts;
    return mapFontsToCssVariables(fonts);
}, function(param) {
    var colors = param.colors, tooltip = param.tooltip;
    return tooltipGlobalStyle(tooltip, colors);
});
var ThemeContext = /*#__PURE__*/ createContext(null);
function useTheme() {
    var ctx = ThemeContext;
    var context = useContext(ctx);
    return context;
}
var ThemeProvider = function(param) {
    var children = param.children, providedTheme = param.theme, overrides = param.overrides;
    var Ctx = ThemeContext;
    // should be replaced with useTheme() when we migrate out of styled-components ThemeProvider
    var parentTheme = useTheme$1();
    var isRootTheme = parentTheme == null;
    var _overrides_breakpoints;
    var theme = useMemo(function() {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            name: providedTheme.name,
            colors: _object_spread({}, providedTheme.colors, overrides === null || overrides === void 0 ? void 0 : overrides.colors),
            fonts: _object_spread({}, providedTheme.fonts, overrides === null || overrides === void 0 ? void 0 : overrides.fonts),
            breakpoints: _to_consumable_array(providedTheme.breakpoints).concat(_to_consumable_array((_overrides_breakpoints = overrides === null || overrides === void 0 ? void 0 : overrides.breakpoints) !== null && _overrides_breakpoints !== void 0 ? _overrides_breakpoints : [])),
            dialog: _object_spread({}, providedTheme.dialog, overrides === null || overrides === void 0 ? void 0 : overrides.dialog),
            tooltip: _object_spread({}, providedTheme.tooltip, overrides === null || overrides === void 0 ? void 0 : overrides.tooltip),
            typography: _object_spread({}, providedTheme.typography, overrides === null || overrides === void 0 ? void 0 : overrides.typography)
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        providedTheme.name
    ]);
    return /*#__PURE__*/ jsx(ThemeProvider$1, {
        theme: theme,
        children: /*#__PURE__*/ jsxs(Ctx.Provider, {
            value: theme,
            children: [
                isRootTheme && /*#__PURE__*/ jsx(GlobalCSSVariablesProvider, {
                    colors: theme.colors,
                    fonts: theme.fonts,
                    tooltip: theme.tooltip
                }),
                children
            ]
        })
    });
};
var ThemeProviderWrapper = function(param) {
    var children = param.children, themes = param.themes, themeName = param.themeName, overrides = param.overrides;
    var providedTheme = themes[themeName];
    // eslint-disable-next-line react/jsx-no-useless-fragment
    if (providedTheme == null) return /*#__PURE__*/ jsx(Fragment, {});
    return /*#__PURE__*/ jsx(ThemeProvider, {
        overrides: overrides,
        theme: providedTheme,
        children: children
    });
};

export { ThemeProviderWrapper as ThemeProvider, mapColorsToCssVariables, mapFontsToCssVariables, useTheme };
